
import { LogJsError } from "./cartxLog";

// 通用错误处理
/**
 * js运行时错误
 * @param msg 错误消息
 * @param url 错误脚本的url
 * @param lineNo 行号
 * @param columnNo 列号
 * @param e 错误对象
 */
// 可能会被覆盖
// window.onerror = (msg, url, lineNo, columnNo, e) => {
//   console.log('22222', msg, url, lineNo, columnNo, e);
//   if (msg != 'ResizeObserver loop limit exceeded') {
//     // 不是重绘
//   }
// }

const handleError = (e:any) => {
  // console.log('1111111', e);
  if (e.message != 'ResizeObserver loop limit exceeded' &&
    e.message != 'ResizeObserver loop completed with undelivered notifications.') {
    // 不是重绘
    if (e.target && (e.target.src || e.target.href)) {
      // LogJsError({
      //   em:'加载资源错误',
      //   url:(e.target.src || e.target.href),
      //   tn: e.target.tagName,
      // })
    } else {
      LogJsError({
        em:e.message,
        es:e.error?.stack,
        url:e.filename,
        lineNo:e.lineno,
        colno:e.colno,
      });
    }
  }
}
window.addEventListener('error', handleError, true);

// window.onerror = (e) => {
//   console.log('222222', e);
// }

// 未处理的promise错误
const handleRejection = (e:any) => {
  // console.log(e);
  if (typeof e.reason === 'object') {
    // console.log('未处理的promise reject事件 详情查看：', e.reason);
    // 抓server error还是有有必要的,能够反应服务器错误
    // 不再上报这些
    const em = `${e.reason?.message || `${e.reason}`}`;
    if (em && !em.includes('Request failed with status code') 
      && !em.includes('系统超时') 
      && !em.includes('系统代码') 
      && em != 'form validate error, get errors by error.errors'
      && em != 'Network Error'
      && em != 'Request aborted'
      ) {
      // 不再抓取请求报错 和 表单验证报错
      LogJsError({
        em:e.reason?.message || `${e.reason}`,
        es:e.reason?.stack,
        type:'promiserejection',
      });
    }
  } else {
    console.log('其他的报错', e);
  }
}
window.addEventListener('unhandledrejection', handleRejection, true);

